import { PipeSize, SpecificationDocument } from "../types/index";

export const Specifications: SpecificationDocument[] = [
    // Pipe 1 (12.75" × 0.5") Specifications
    // WPS Documents
    {
      id: '1',
      fileName: 'BA-WPS-001-Rev2.pdf',
      type: 'WPS',
      pipeId: 0,
      uploadDate: '2024-03-15T10:30:00Z'
    },
    // Weld Process
    {
      id: '2',
      fileName: 'BA-WP-001-Rev1.pdf',
    type: 'WELD_PROCESS',
      pipeId: 0,
      uploadDate: '2024-03-15T11:15:00Z',
      details: {
        weldProcess: {
          processType: 'GMAW',
          wireType: 'ER70S-6',
          wireSize: '1.2mm',
          shieldingGas: 'Ar/CO2 (80/20)',
          flowRate: '18-22',
          voltage: '22-26',
          amperage: '180-220'
        }
      }
    },
    // Drawings
    {
      id: '3',
      fileName: 'BA-DWG-001-Rev1.pdf',
      type: 'DRAWING',
      pipeId: 0,
      uploadDate: '2024-03-14T09:00:00Z'
    },
    // Inspection Procedure
    {
      id: '4',
      fileName: 'BA-IP-001-Rev1.pdf',
      type: 'INSPECTION_PROCEDURE',
      pipeId: 0,
      uploadDate: '2024-03-14T10:00:00Z',
      details: {
        inspectionProcedure: {
          method: 'Ultrasonic Testing (UT)',
          equipment: 'OmniScan MX2 UT System',
          frequency: 'Every weld joint',
          coverage: '100% circumferential coverage',
          calibrationRequirements: 'Daily calibration with reference block',
          standardName: 'API 1104 Section 9'
        }
      }
    },
    // Acceptance Criteria
    {
      id: '5',
      fileName: 'BA-AC-001-Rev1.pdf',
      type: 'ACCEPTANCE_CRITERIA',
      pipeId: 0,
      uploadDate: '2024-03-14T11:00:00Z',
      details: {
        acceptanceCriteria: {
          standard: 'API 1104 Section 9',
          defectTypes: ['porosity', 'lack-of-fusion', 'undercut', 'cracks', 'slag-inclusion'],
          tolerances: 'Max 2mm for undercut, No cracks allowed',
          repairProcedure: 'As per WPS-REP-001'
        }
      }
    },
    // Pass Configuration
    {
      id: '6',
      fileName: 'BA-PC-001-Rev1.pdf',
      type: 'PASS_CONFIG',
      pipeId: 0,
      uploadDate: '2024-03-14T12:00:00Z',
      details: {
        passConfig: {
          numberOfPasses: 3,
          passes: [
            {
              name: 'Root Pass',
              sequence: 1,
              requirements: 'Complete penetration, no undercut'
            },
            {
              name: 'Hot Pass',
              sequence: 2,
              requirements: 'Clean, no slag inclusions'
            },
            {
              name: 'Cap Pass',
              sequence: 3,
              requirements: 'Smooth transition, no excessive reinforcement'
            }
          ]
        }
      }
    },
    // Fitment Readings
    {
      id: '7',
      fileName: 'BA-FR-001-Rev1.pdf',
      type: 'FITMENT_READINGS',
      pipeId: 0,
      uploadDate: '2024-03-14T13:00:00Z',
      details: {
        fitmentReadings: {
          gapTolerance: '2.5',
          hiLowTolerance: '1.5',
          ovality: '1%',
          straightness: '3mm/m',
          measurementPoints: 4,
          numberOfReadings: 8,
          landMin: '0.5',
          landMax: '1.0',
          wallThicknessMin: '0.45',
          wallThicknessMax: '0.55'
        }
      }
    },
    // Welding Position
    {
      id: '8',
      fileName: 'BA-WP-001-Rev1.pdf',
      type: 'WELDING_POSITION',
      pipeId: 0,
      uploadDate: '2024-03-14T14:00:00Z',
      details: {
        weldingPosition: {
          position: '5G',
          rotationAllowed: false,
          maxRotationAngle: '0',
          fixedPosition: 'Horizontal',
          restrictions: ['No downhill welding', 'Fixed pipe position']
        }
      }
    },

    // Pipe 2 (16.0" × 0.75") Specifications
    // WPS Documents
    {
      id: '9',
      fileName: 'BA-WPS-002-Rev1.pdf',
      type: 'WPS',
      pipeId: 1,
      uploadDate: '2024-03-16T14:20:00Z'
    },
    // Weld Process
    {
      id: '10',
      fileName: 'BA-WP-002-Rev1.pdf',
      type: 'WELD_PROCESS',
      pipeId: 1,
      uploadDate: '2024-03-16T15:00:00Z',
      details: {
        weldProcess: {
          processType: 'FCAW',
          wireType: 'E71T-1',
          wireSize: '1.6mm',
          shieldingGas: 'CO2',
          flowRate: '20-25',
          voltage: '24-28',
          amperage: '200-250'
        }
      }
    },
    // Drawings
    {
      id: '11',
      fileName: 'BA-DWG-002-Rev1.pdf',
      type: 'DRAWING',
      pipeId: 1,
      uploadDate: '2024-03-16T16:00:00Z'
    },
    // Inspection Procedure
    {
      id: '12',
      fileName: 'BA-IP-002-Rev1.pdf',
      type: 'INSPECTION_PROCEDURE',
      pipeId: 1,
      uploadDate: '2024-03-16T17:00:00Z',
      details: {
        inspectionProcedure: {
          method: 'Radiographic Testing (RT)',
          equipment: 'Gamma Ray Source IR-192',
          frequency: '100% of welds',
          coverage: 'Full circumferential coverage',
          calibrationRequirements: 'Image Quality Indicator (IQI) verification',
          standardName: 'API 1104 Section 8'
        }
      }
    },
    // Acceptance Criteria
    {
      id: '13',
      fileName: 'BA-AC-002-Rev1.pdf',
      type: 'ACCEPTANCE_CRITERIA',
      pipeId: 1,
      uploadDate: '2024-03-16T18:00:00Z',
      details: {
        acceptanceCriteria: {
          standard: 'API 1104 Section 8',
          defectTypes: ['porosity', 'incomplete-fusion', 'cracks', 'burn-through'],
          tolerances: 'Max 3mm for porosity clusters, No linear defects',
          repairProcedure: 'As per WPS-REP-002'
        }
      }
    },
    // Pass Configuration
    {
      id: '14',
      fileName: 'BA-PC-002-Rev1.pdf',
      type: 'PASS_CONFIG',
      pipeId: 1,
      uploadDate: '2024-03-16T19:00:00Z',
      details: {
        passConfig: {
          numberOfPasses: 4,
          passes: [
            {
              name: 'Root Pass',
              sequence: 1,
              requirements: 'Full penetration, no suck-back'
            },
            {
              name: 'Hot Pass',
              sequence: 2,
              requirements: 'Clean, no inclusions'
            },
            {
              name: 'Fill Pass',
              sequence: 3,
              requirements: 'Even coverage, no cold lap'
            },
            {
              name: 'Cap Pass',
              sequence: 4,
              requirements: 'Uniform reinforcement, no undercut'
            }
          ]
        }
      }
    },
    // Fitment Readings
    {
      id: '15',
      fileName: 'BA-FR-002-Rev1.pdf',
      type: 'FITMENT_READINGS',
      pipeId: 1,
      uploadDate: '2024-03-16T20:00:00Z',
      details: {
        fitmentReadings: {
          gapTolerance: '3.0',
          hiLowTolerance: '2.0',
          ovality: '1.5%',
          straightness: '4mm/m',
          measurementPoints: 6,
          numberOfReadings: 10,
          landMin: '0.8',
          landMax: '1.2',
          wallThicknessMin: '0.70',
          wallThicknessMax: '0.80'
        }
      }
    },
    // Welding Position
    {
      id: '16',
      fileName: 'BA-WP-002-Rev1.pdf',
      type: 'WELDING_POSITION',
      pipeId: 1,
      uploadDate: '2024-03-16T21:00:00Z',
      details: {
        weldingPosition: {
          position: '6G',
          rotationAllowed: false,
          maxRotationAngle: '0',
          fixedPosition: '45° Fixed',
          restrictions: ['No downhill welding', 'Fixed pipe position', 'Qualified welders only']
        }
      }
    },
    {
      id: '8',
      fileName: 'BA-BV-001-Rev1.pdf',
      type: 'BEVEL',
      pipeId: 0,
      uploadDate: '2024-03-14T14:00:00Z',
      details: {
        bevel: {
          type: 'V-Groove',
          angle: '30°',
          rootFace: '1.5mm',
          rootGap: '2.0mm',
          landThickness: '1.0mm',
          preparation: 'Machine beveling'
        }
      }
    },
    {
      id: '17',
      fileName: 'BA-BV-002-Rev1.pdf',
      type: 'BEVEL',
      pipeId: 1,
      uploadDate: '2024-03-16T22:00:00Z',
      details: {
        bevel: {
          type: 'Compound Bevel',
          angle: '30° + 15°',
          rootFace: '2.0mm',
          rootGap: '2.5mm',
          landThickness: '1.5mm',
          preparation: 'CNC machining'
        }
      }
    }
  ];
  export const pipeSizes: PipeSize[] = [
    {
      size: '12.75',
      wallThickness: '0.5',
      buckleArrestors: '2',
      numberOfPipes: '10',
      pipeLength: '12.5',
      numberOfForges: '4',
      outputAssemblyLength: '120',
      manufacturer: 'Manufacturer A'
    },
    {
      size: '16.0',
      wallThickness: '0.75',
      buckleArrestors: '2',
      numberOfPipes: '8',
      pipeLength: '12.5',
      numberOfForges: '4',
      outputAssemblyLength: '96',
      manufacturer: 'Manufacturer B'
    }
  ];